import { Editor, Path, Range } from "slate"

export const checkIfIsSelectionOnlyInTable = (editor: Editor, tablePath: Path) => {
  if(!editor.selection) return
  const tableRange = Editor.range(editor, tablePath)
  return Range.includes(tableRange, Range.start(editor.selection)) && Range.includes(tableRange, Range.end(editor.selection))

}